import {
  Text,
  useZustandModalKitStore,
  EModalTypes,
  zustandModalKitSelector,
} from 'react-gldn-kit';
import { useTransportControllers } from 'react-render-hooks';

import { ERequestIds } from 'react-memory-optimization/dist/lib/binary/types';

import ComponentKitBaseButton from 'components/ui/KitComponents/Buttons/BaseButton';

import styles from './ClaimConfirmation.module.css';

const ClaimConfirmation = () => {
  const { sendCommand } = useTransportControllers();

  const {
    id: operationId,
    previousModalType,
    titleKey = 'bonusCabinet.cancelBonus.title',
    bodyKey = 'bonusCabinet.cancelBonus.body',
    buttonKey = 'bonusCabinet.cancelBonus.cancelOperation',
  } = useZustandModalKitStore(
    zustandModalKitSelector.getModalAdditionalInfoSelector
  );

  const closeAndOpen = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const close = useZustandModalKitStore(
    zustandModalKitSelector.setModalInfoAction
  );

  const onClose = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (previousModalType) {
      closeAndOpen(previousModalType);

      return;
    }

    close(EModalTypes.Unknown);
  };

  const handleCancelOperation = (e: React.MouseEvent<HTMLDivElement>) => {
    sendCommand(
      '23x',
      {
        operationId,
        requestId: ERequestIds.CancelOperation,
      },
      true
    );

    onClose(e);
  };

  return (
    <div>
      <div className={styles.contentSubTitle}>
        <Text idT={bodyKey} />
      </div>

      <ComponentKitBaseButton
        text={buttonKey}
        size="--button-full"
        buttonHeight="--button-height-full"
        color="primary"
        handleClick={handleCancelOperation}
        centreText
      />
    </div>
  );
};

export default ClaimConfirmation;
